import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import _ from 'underscore';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

const log = new Logger('OBLIGATIONS_DETAILS', LOG_LEVELS.DEBUG);

class ObligationsDetails extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        log.debug('render(): ', this.props);
        if (this.props.data === undefined || _.isEmpty(this.props.data)) {
            return (<div><LanguageStringResolver string='MTD_Report_NoData'/></div>);
        }
        return (
            <div>
                <div className="content-area">
                    <s-container>
                        <h1><span><LanguageStringResolver string='MTD_Report_Title'/></span></h1>
                        <table className="card-table">
                            <thead>
                                <tr>
                                    <th>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_name')}</th>
                                    <th className="text-align-right">{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_value')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_vatDueSales')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.vatDueSales}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_vatDueAcquisitions')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.vatDueAcquisitions}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_totalVatDue')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.totalVatDue}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_vatReclaimedCurrPeriod')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.vatReclaimedCurrPeriod}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_netVatDue')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.netVatDue}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_totalValueSalesExVAT')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.totalValueSalesExVAT}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_totalValuePurchasesExVAT')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.totalValuePurchasesExVAT}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_totalValueGoodsSuppliedExVAT')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.totalValueGoodsSuppliedExVAT}/></span></td>
                                </tr>
                                <tr>
                                    <td><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'MTD_Report_totalAcquisitionsExVAT')}</span></td>
                                    <td className="text-align-right"><span><FormattedCurrencyValue value={this.props.data.totalAcquisitionsExVAT}/></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </s-container>
                </div>
                <div className="clear"></div>
            </div>
        )

    }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages,
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ObligationsDetails);